// src/admin/AdminNav/pages/Orders.jsx
import React, {useEffect, useState} from "react";
import {supabase} from "../../../../supabaseClient";
import "./OrdersPage.css";

const OrdersPage = () => {
    const [orders, setOrders] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [limit, setLimit] = useState(20);
    const [hasMore, setHasMore] = useState(true);
    const [confirmingOrderId, setConfirmingOrderId] = useState(null);

    const fetchOrders = async () => {
        setFetching(true);
        const {data, error} = await supabase
            .from("orders")
            .select("id, user_id, phoneNumber, deliveryAddress, deliveryName, order_created, done")
            .eq("done", false)
            .order("order_created", {ascending: true})
            .range(0, limit - 1);

        if (error) {
            console.error("Error fetching orders:", error);
        } else {
            setOrders(data);
            setHasMore(data.length === limit);
        }
        setFetching(false);
    };

    useEffect(() => {
        fetchOrders();
    }, [limit]);

    const handleLoadMore = () => {
        setLimit((prev) => prev + 20);
    };

    const handleMarkDone = async (orderId) => {
        const {error} = await supabase.from("orders").update({done: true}).eq("id", orderId);

        if (error) {
            console.error("Error marking order as done:", error);
        } else {
            setOrders((prevOrders) => prevOrders.filter((order) => order.id !== orderId));
            setConfirmingOrderId(null);
        }
    };

    return (
        <div className="orders-page">
            <h2>Beställningar</h2>
            <div className="orders-table">
                <div className="table-header">
                    <span>ID</span>
                    <span>Användar-ID</span>
                    <span>Telefonnummer</span>
                    <span>Leveransadress</span>
                    <span>Leveransnamn</span>
                    <span>Skapad</span>
                    <span>Status</span>
                </div>
                {orders.map((order) => (
                    <div key={order.id} className="table-row">
                        <span>{order.id}</span>
                        <span>{order.user_id}</span>
                        <span>{order.phoneNumber}</span>
                        <span>{order.deliveryAddress}</span>
                        <span>{order.deliveryName}</span>
                        <span>{new Date(order.order_created).toLocaleString()}</span>
                        <span className="status-pending">
                            {confirmingOrderId === order.id ? (
                                <button className="confirm-button" onClick={() => handleMarkDone(order.id)}>
                                    SÄKER?
                                </button>
                            ) : (
                                <button onClick={() => setConfirmingOrderId(order.id)}>Ej Klar</button>
                            )}
                        </span>
                    </div>
                ))}
            </div>

            {hasMore ? (
                <button onClick={handleLoadMore} className="load-more-btn" disabled={fetching}>
                    {fetching ? "Hämtar..." : "Hämta fler"}
                </button>
            ) : (
                <p className="no-more">Inga fler beställningar att hämta.</p>
            )}
        </div>
    );
};

export default OrdersPage;
